import { render, staticRenderFns } from "./SystemUserManagement.vue?vue&type=template&id=94b737b2&scoped=true&"
import script from "./SystemUserManagement.vue?vue&type=script&lang=js&"
export * from "./SystemUserManagement.vue?vue&type=script&lang=js&"
import style0 from "./SystemUserManagement.vue?vue&type=style&index=0&id=94b737b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94b737b2",
  null
  
)

export default component.exports